import { useState } from 'react';

const useModal = (
	allowShow = function () { return true; },
	allowClose = function () { return true; }
) => {
	const [isShowing, setIsShowing] = useState(false);
	const [modalData, setModalData] = useState(null);

	function open(data) {
		let newOpenValue = true;
		if (allowShow && typeof allowShow === "function") {
			newOpenValue = Boolean(allowShow());
		}
		setModalData(data);
		setIsShowing(newOpenValue);
	}

	function close() {
		let newOpenValue = false;
		if (allowClose && typeof allowClose === "function") {
			newOpenValue = !Boolean(allowClose());
		}
		setIsShowing(newOpenValue);
	}

	return {
		isShowing,
		modalData,
		open,
		close,
	}
};

export default useModal;